import React from "react";

import { SubscriptionCardProps } from "./models";

import {
	Button,
	Box,
	Card,
	CardContent,
	Typography,
	List,
	ListItem,
	ListItemIcon,
	ListItemText
} from "@mui/material";

import { Trans } from "@lingui/macro";
import DoneIcon from '@mui/icons-material/Done';
import ShoppingCartSharpIcon from '@mui/icons-material/ShoppingCartSharp';

import "./style.scss";

export default class SubscriptionCard extends React.Component<SubscriptionCardProps, {}>
{
	constructor(props: any) {
		super(props);

		this.state = {
			confirmDeleteDialogShow: false,
			repeatVerifieCustomer: false
		};
	}

	buyOnClick = () => {
		this.props.onClickHandler(this.props.product.id);
	};

	render() {
		return (<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				maxWidth: 350,
			}}>
			<Card sx={{ borderRadius: 5, minWidth: 300, minHeight: 200 }} className="subscription-card">
				<CardContent>
					<Typography variant="h5" component="div" color="#FFFFFF" textTransform="uppercase" sx={{ mt: 1 }}>
						{this.props.product.name}
					</Typography>
				</CardContent>
			</Card>
			<List sx={{ mt: 5, minHeight: 70 }}>
				<ListItem disablePadding>
					<ListItemIcon>
						<DoneIcon sx={{ color: "#FFFFFF" }} fontSize="small" />
					</ListItemIcon>
					<ListItemText>
						<Typography variant="h3" color="#FFFFFF" component="div" sx={{ fontSize: 18 }}>
							{this.props.product.description}
						</Typography>
					</ListItemText>
				</ListItem>
			</List>
			<Button variant={"contained"}
				sx={{ mt: 5 }}
				color={"primary"}
				size={"large"}
				endIcon={<ShoppingCartSharpIcon fontSize="small" />}
				onClick={() => (this.buyOnClick())}
			>
				<Trans id="sc-subscribe">Acquista</Trans>
			</Button>
		</Box>);
	}
}
